import { render, staticRenderFns } from "./VideoCancelled.vue?vue&type=template&id=7d51f7fd&scoped=true&"
import script from "./VideoCancelled.vue?vue&type=script&lang=js&"
export * from "./VideoCancelled.vue?vue&type=script&lang=js&"
import style0 from "./VideoCancelled.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoCancelled.vue?vue&type=style&index=1&id=7d51f7fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d51f7fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCardText,VIcon})
